import styled from 'styled-components';

import { mediaQuery } from '@savgroup-front-common/core/grid/helpers';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { transparentize } from '@savgroup-front-common/primitive/helpers/cssColor';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $StepProgressWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${spacing(10)};
  ${mediaQuery.sm`
    margin-bottom: ${spacing(24)}
  `};
  justify-content: center;
`;

export const $StepProgressItem = styled.div`
  display: flex;
  flex-direction: column;
  width: ${spacing(20)};
  justify-content: center;
  align-items: center;
`;

export const $StepProgressCircle = styled.div<{ $active?: boolean }>`
  width: ${spacing('xxl')};
  height: ${spacing('xxl')};
  border-radius: 50%;
  background-color: ${({ theme, $active = false }) =>
    $active
      ? theme.colors.primary
      : transparentize(0.95, theme.colors.paragraphTextColor)};
  color: ${({ theme, $active }) =>
    $active ? theme.colors.white : theme.colors.mainTextColor};
  font-weight: ${fontWeight('normal')};
  ${fontStyle('sm')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const $StepProgressLabel = styled.div<{ $active?: boolean }>`
  font-weight: ${fontWeight('normal')};
  ${fontStyle('xs')};
  margin-top: ${spacing(2.5)};
  color: ${({ theme, $active = false }) =>
    $active ? theme.colors.primary : theme.colors.mainTextColor};
`;

export const $StepProgressSeparator = styled.div<{ $active?: boolean }>`
  display: flex;
  flex: 1;
  height: ${spacing('xxl')};
  min-width: ${spacing(12)};
  align-self: flex-start;
  align-items: center;
  &:after {
    content: '';
    height: ${spacing('xxs')};
    width: 100%;
    background: ${({ theme, $active = false }) =>
      $active
        ? theme.colors.primary
        : transparentize(0.95, theme.colors.paragraphTextColor)};
    border-radius: 999px;
  }

  &:last-child {
    display: none;
  }
`;
